import { Pagination } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePagination, useSortBy, useTable } from "react-table";
import Tabination from "../../reusableComponents/Tabination";
import { setIsLoading } from "../../store/reducers/authSlice";
import { returnErrors } from "../../store/reducers/error";
import {
  getRiskManagement,
  getPayoutTracker,
  baseUrl,
} from "../../utils/api/apis";
import "./style.scss";
import axios from "axios";
import { Button, message } from "antd";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import moment from "moment";
import StageStatistics from "../../components/AdminOverview/StageStatistics";
import {
  formatCurrency,
  formatCurrencyWithoutDecimal,
} from "../../utils/helpers/string";
import { DateRangePicker, DatePicker } from "rsuite";
import "rsuite/DateRangePicker/styles/index.css";
import "rsuite/DatePicker/styles/index.css";
import dayjs from "dayjs";
import Select from "react-select";
import { country } from "../../utils/constants/country";
import { FormatUSD, statusToTag } from "../../utils/string";
import ApexChart from "../../components/AdminOverview/PieChart/Index";

function AdminOverview() {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState(0);
  const [riskData, setRiskData] = useState({});
  console.log(riskData, "riskDatariskData");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [selectedDates, setSelectedDates] = useState([null, null]);
  const [overallStats, setOverallStats] = useState({
    overall_payable_amount: 0,
    overall_number_of_payouts: 0,
  });
  const [exportLoading, setExportLoading] = useState(false);
  const [searchValue, setSearchValue] = useState({
    start_date: null,
    end_date: null,
    platform: null,
    account_type: "",
    consistency: "",
    ordering: "",
  });
  const [submittedSearchValue, setSubmittedSearchValue] = useState(null);

  const isDirty = useMemo(() => {
    if (!submittedSearchValue) return true;
    return (
      searchValue?.account_type !== submittedSearchValue?.account_type ||
      searchValue?.consistency !== submittedSearchValue?.consistency ||
      searchValue?.ordering !== submittedSearchValue?.ordering ||
      searchValue?.start_date !== submittedSearchValue?.start_date ||
      searchValue?.end_date !== submittedSearchValue?.end_date
    );
  }, [searchValue, submittedSearchValue]);

  const displayedOverallStats = useMemo(() => {
    if (activeTab === 7 && isDirty) {
      return {
        overall_payable_amount: 0,
        overall_number_of_payouts: 0,
      };
    }
    return overallStats;
  }, [activeTab, isDirty, overallStats]);

  const handleSubmit = () => {
    setSubmittedSearchValue({ ...searchValue });
  };

  const { selectedBrand } = useSelector((state) => state.brand);
  const fetchRiskData = async () => {
    dispatch(setIsLoading(true));

    try {
      const response = await getRiskManagement(
        idToken,
        searchValue,
        selectedBrand,
      );
      console.log(response, "Risk Management API Response");

      if (response?.status < 399) {
        setRiskData(response.data);
      } else {
        dispatch(returnErrors("Error getting risk management data"));
      }
    } catch (error) {
      console.error("Error fetching data", error);
      dispatch(returnErrors("Error fetching data"));
    }

    dispatch(setIsLoading(false));
  };

  useEffect(() => {
    if (activeTab !== 7) {
      fetchRiskData();
    }
  }, [idToken, searchValue, activeTab]);

  const columns = useMemo(
    () => [
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "No of Payments",
        accessor: "no_of_payments",
        enableSortBy: true,
      },

      {
        Header: "Percent Payments",
        accessor: "percent_payments",
        Cell: ({ value }) => <div>{value?.toFixed(2)}</div>,
        enableSortBy: true,
      },
      {
        Header: "Total Payments",
        accessor: "total_payments",
        Cell: ({ value }) => <div>{FormatUSD(value)}</div>,
        enableSortBy: true,
      },
    ],
    [],
  );
  const columnsForPayout = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ value }) => (
          <div>{moment.utc(value).format("DD-MM-YYYY")}</div>
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => <div className={statusToTag(value)}>{value}</div>,
      },
      {
        Header: "Payout Method",
        accessor: "payout_method",
        Cell: ({ value }) => <div>{value}</div>,
      },
      {
        Header: "Payout Amount",
        accessor: "payout_amount",
        Cell: ({ value }) => formatCurrency(value),
      },
      {
        Header: "Amended Amount",
        accessor: "amended_amount",
        Cell: ({ value }) => formatCurrency(value),
      },
      // {
      //   Header: "Total Requested Payout",
      //   accessor: "total_requested_payout",
      // },
      {
        Header: "Starting Balance",
        accessor: "starting_balance",
        Cell: ({ value }) => formatCurrencyWithoutDecimal(value),
      },
      {
        Header: "Plan Name",
        accessor: "plan_name",
      },
    ],
    [],
  );
  const columnsForRevenue = useMemo(
    () => [
      {
        Header: "Total Profit",
        accessor: "total_profit",
        Cell: ({ value }) => (
          <div
            style={{ color: value > 0 ? "#4cb944" : value < 0 && "#ff5733" }}
          >
            {formatCurrency(value)}
          </div>
        ),
      },
      {
        Header: "Total Revenue",
        accessor: "total_revenue",
        Cell: ({ value }) => <div>{formatCurrency(value)}</div>,
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (
          <div>{moment.utc(value).format("DD-MM-YYYY")}</div>
        ),
      },
      {
        Header: "Total Payout Requested",
        accessor: "total_payout_requested",
        Cell: ({ value }) => <div>{formatCurrency(value)}</div>,
      },
      {
        Header: "Total Payout Approved",
        accessor: "total_payout_approved",
        Cell: ({ value }) => <div>{formatCurrency(value)}</div>,
      },
      {
        Header: "Total No Accounts",
        accessor: "total_no_accounts",
      },
      // {
      //   Header: "Profit Split",
      //   accessor: "profit_split",
      // },
      {
        Header: "Revenue from Payments",
        accessor: "revenue_from_payments",
        Cell: ({ value }) => <div>{formatCurrency(value)}</div>,
      },
    ],
    [],
  );

  console.log(
    riskData?.revenue_management?.revenue_management,
    "Countrywise Stats Data",
  );

  const location = useLocation();

  const items = [
    {
      name: "Overview",
      path: "overview",
    },
    {
      name: "1 Step",
      path: "step_1",
    },
    {
      name: "2 Step",
      path: "step_2",
    },
    {
      name: (
        <>
          {selectedBrand?.brand === "equity_edge"
            ? "Instant"
            : "Instant Funding"}
        </>
      ),
      path: "pro_edge",
    },
    {
      name: "Countrywise Stats",
      path: "countrywise",
    },
    {
      name: "Payout Lists",
      path: "payout-lists",
    },
    {
      name: "Revenue Management",
      path: "revenue-management",
    },
    {
      name: "Payout Tracker",
      path: "payout-tracker",
    },
  ];

  useEffect(() => {
    const currentPath = location.pathname;

    switch (currentPath) {
      case "/risk-management/overview":
        setActiveTab(0);
        break;
      case "/risk-management/step_1":
        setActiveTab(1);
        break;
      case "/risk-management/step_2":
        setActiveTab(2);
        break;
      case "/risk-management/pro_edge":
        setActiveTab(3);
        break;
      case "/risk-management/countrywise":
        setActiveTab(4);
        break;
      case "/risk-management/payout-lists":
        setActiveTab(5);
        break;
      case "/risk-management/revenue-management":
        setActiveTab(6);
        break;
      case "/risk-management/payout-tracker":
        setActiveTab(7);
        break;
    }
  }, [location.pathname]);

  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      const [start_date, end_date] = dates;
      setSearchValue({
        ...searchValue,
        start_date: start_date ? dayjs(start_date).format("YYYY-MM-DD") : null,
        end_date: end_date ? dayjs(end_date).format("YYYY-MM-DD") : null,
      });
      setSelectedDates(dates); // Update the selected dates in state
    }
  };

  const handleReset = () => {
    setSelectedDates([null, null]); // Reset the selected dates
    setSearchValue({
      start_date: null,
      end_date: null,
      platform: null,
      account_type: "",
      consistency: "",
      ordering: "",
    });
    setSubmittedSearchValue(null);
  };

  const handleExportCsv = async () => {
    if (!idToken) return;

    if (!selectedDates || !selectedDates[0] || !selectedDates[1]) {
      message.warning("Please select a date range before exporting.");
      return;
    }

    const start_date = dayjs(selectedDates[0]).format("YYYY-MM-DD");
    const end_date = dayjs(selectedDates[1]).format("YYYY-MM-DD");

    setExportLoading(true);
    try {
      const params = {
        export: "csv",
        start_date,
        end_date,
        page_size: 10000,
      };
      if (searchValue?.account_type && searchValue.account_type !== "all") {
        params.account_type = searchValue.account_type;
      }
      if (searchValue?.consistency) {
        params.consistency = searchValue.consistency;
      }
      if (searchValue?.ordering && searchValue.ordering !== "all") {
        params.ordering = searchValue.ordering;
      }

      const response = await axios.get(
        `${baseUrl}account/admin/payout-tracker/`,
        {
          headers: { Authorization: `Bearer ${idToken}` },
          params,
          responseType: "blob",
        },
      );

      // Trigger download
      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `payout-tracker-${start_date}-to-${end_date}.csv`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV payout tracker:", error);
      message.error("Failed to export CSV.");
    } finally {
      setExportLoading(false);
    }
  };

  const [bodyClassName, setBodyClassName] = useState("");

  useEffect(() => {
    const updateBodyClassName = () => {
      const currentClassName = document.body.className;
      setBodyClassName(currentClassName);
    };

    updateBodyClassName();

    const observer = new MutationObserver(updateBodyClassName);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const [activeTheme, setActiveTheme] = useState("");

  useEffect(() => {
    if (bodyClassName !== "dark-theme") {
      setActiveTheme("dark-theme");
    } else {
      setActiveTheme("light-theme");
    }
  }, [bodyClassName]);
  const [payoutList, setPayoutList] = useState([]);
  const [revenueList, setRevenueList] = useState([]);

  const planOptions = [
    {
      label: "All",
      value: "payment_payout_list",
      newValue: "all",
    },
    { label: "1 Step", value: "step1_payout_list", newValue: "step1" },
    {
      label: "1 Step EE",
      value: "step1_EE_payout_list",
      newValue: "1_Step_EE",
    },
    {
      label: "1 Step Swift",
      value: "step1_swift_payout_list",
      newValue: "1_Step_Swift",
    },
    // {
    //   label: "1 Step Lite",
    //   value: "step1_lite_payout_list",
    //   newValue: "1_Step_Lite",
    // },
    { label: "2 Step", value: "step2_payout_list", newValue: "step2" },
    {
      label: "2 Step EE",
      value: "step2_EE_payout_list",
      newValue: "2_Step_EE",
    },
    {
      label: "2 Step Swift",
      value: "step2_swift_payout_list",
      newValue: "2_Step_Swift",
    },
    // {
    //   label: "2 Step Lite",
    //   value: "step2_lite_payout_list",
    //   newValue: "2_Step_Lite",
    // },

    ...(selectedBrand?.brand === "equity_edge"
      ? [
          {
            label: "Instant",
            value: "proedge_payout_list",
            newValue: "proedge",
          },
        ]
      : [
          {
            label: "Instant Funding",
            value: "instant_funded",
            newValue: "instant_funded",
          },
        ]),
  ];
  const revenuePlanOptions = [
    {
      label: "All",
      value: "revenue_management",
    },
    { label: "1 Step", value: "step1" },
    { label: "1 Step EE", value: "step1_EE" },
    { label: "1 Step Swift", value: "step1_Swift" },
    // { label: "1 Step Lite", value: "step1_lite" },
    { label: "2 Step", value: "step2" },
    { label: "2 Step EE", value: "step2_EE" },
    { label: "2 Step Swift", value: "step2_Swift" },
    // { label: "2 Step Lite", value: "step2_lite" },
    ...(selectedBrand?.brand === "equity_edge"
      ? [
          {
            label: "Instant",
            value: "proedge",
          },
        ]
      : [
          {
            label: "Instant Funding",
            value: "instant_funded",
          },
        ]),
  ];

  const [selectedPlanValue, setSelectedPlanValue] = useState(planOptions[0]);

  const [selectedRevenuePlan, setSelectedRevenuePlan] = useState(
    revenuePlanOptions[0],
  );
  console.log(
    selectedPlanValue,
    riskData,
    "selectedPlanValueselectedPlanValue",
  );
  const [paymentStats, setPaymentStats] = useState({});
  const [payoutStats, setPayoutStats] = useState({});

  const accountSizeOption = useMemo(() => {
    if (
      selectedBrand?.brand === "equity_edge" ||
      selectedBrand?.brand === "crypto_edge"
    ) {
      const stats =
        activeTab === 5 ? payoutStats : activeTab === 6 ? paymentStats : null;

      return [
        { label: "All", value: "total" },
        ...Object.keys(stats || {})
          .filter((key) => key !== "total")
          .map((key) => ({
            label: Number(key),
            value: Number(key),
          })),
      ];
    }
    return [];
  }, [selectedBrand?.brand, activeTab, payoutStats, paymentStats]);

  const [accountSizeValue, setAccountSizeValue] = useState(null);

  useEffect(() => {
    if (
      selectedBrand?.brand === "equity_edge" ||
      selectedBrand?.brand === "crypto_edge"
    ) {
      setAccountSizeValue({ label: "All", value: "total" });
    } else {
      setAccountSizeValue(null);
    }
  }, [selectedBrand?.brand, activeTab]);

  useEffect(() => {
    if (selectedPlanValue && riskData?.revenue_management) {
      setPayoutList(riskData.payout_list[selectedPlanValue?.value] || []);
      setPayoutStats(
        riskData?.planwise_payout_stats[selectedPlanValue?.newValue],
      );

      if (
        selectedBrand?.brand === "equity_edge" ||
        selectedBrand?.brand === "crypto_edge"
      ) {
        setAccountSizeValue(accountSizeOption[0]);
      }
    }
  }, [selectedPlanValue, riskData]);

  useEffect(() => {
    if (selectedRevenuePlan && riskData) {
      setRevenueList(
        selectedRevenuePlan.value === "revenue_management"
          ? riskData?.revenue_management
          : riskData?.revenue_planwise[selectedRevenuePlan.value] || [],
      );
      setPaymentStats(
        selectedRevenuePlan.value === "revenue_management"
          ? riskData?.payment_stats_planwise?.all
          : riskData?.payment_stats_planwise[selectedRevenuePlan?.value],
      );
      if (
        selectedBrand?.brand === "equity_edge" ||
        selectedBrand?.brand === "crypto_edge"
      ) {
        setAccountSizeValue(accountSizeOption[0]);
      }
    }
  }, [selectedRevenuePlan, riskData]);

  return (
    <>
      <Tabination
        variant={3}
        tabItems={items}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      <div className="support_wrapper support">
        <Tabination
          variant={6}
          showMobTabs={true}
          tabItems={items}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />{" "}
        <div className="papercon funded datepicker overview_filters_header">
          <div className="filters_left_side">
            <div className="platform_inputs_row">
              {activeTab === 4 || activeTab === 5 || activeTab === 6 ? (
                <div className="col1_bottom_lower">
                  <Select
                    placeholder="Search for a country"
                    // styles={customStyles}
                    isMulti
                    className="react-select-country"
                    options={country.map((items) => ({
                      label: items.country,
                      value: items.country,
                      iso: items.iso,
                    }))}
                    onChange={(selectedOptions) => {
                      const safeOptions = Array.isArray(selectedOptions)
                        ? selectedOptions
                        : [];
                      const selectedCountries = safeOptions.map(
                        (option) => option.value,
                      );
                      const selectedIsos = safeOptions.map(
                        (option) => option.iso,
                      );

                      setSearchValue((pre) => ({
                        ...pre,
                        country: [...selectedCountries, ...selectedIsos],
                      }));
                    }}
                  />
                </div>
              ) : (
                <></>
              )}

              {selectedBrand.brand === "equity_edge" && activeTab !== 7 && (
                <div className="col1_bottom_lower">
                  <Select
                    placeholder="Search for a platform"
                    isMulti={false}
                    className="react-select-country"
                    options={[
                      { label: "All", value: null },
                      { label: "Match-Trade", value: "matchtrade" },
                      { label: "MT5", value: "mt5" },
                      { label: "Trade-Locker", value: "tradelocker" },
                    ]}
                    value={[
                      { label: "All", value: null },
                      { label: "Match-Trade", value: "matchtrade" },
                      { label: "MT5", value: "mt5" },
                      { label: "Trade-Locker", value: "tradelocker" },
                    ].find((item) => item.value === searchValue.platform)}
                    onChange={(selectedOptions) => {
                      setSearchValue((pre) => ({
                        ...pre,
                        platform: selectedOptions.value,
                      }));
                    }}
                  />
                </div>
              )}

              {activeTab === 7 && (
                <>
                  <div className="col1_bottom_lower">
                    <Select
                      placeholder="Select Plan"
                      isMulti={false}
                      className="react-select-country"
                      options={[
                        { label: "All", value: "all" },
                        { label: "1 Step", value: "1_step" },
                        { label: "2 Step", value: "2_step" },
                        { label: "Instant", value: "instant" },
                      ]}
                      value={
                        [
                          { label: "All", value: "all" },
                          { label: "1 Step", value: "1_step" },
                          { label: "2 Step", value: "2_step" },
                          { label: "Instant", value: "instant" },
                        ].find(
                          (item) => item.value === searchValue.account_type,
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        setSearchValue((pre) => ({
                          ...pre,
                          account_type: selectedOption?.value || "",
                        }));
                      }}
                    />
                  </div>
                  <div
                    className="col1_bottom_lower"
                    style={{ minWidth: "160px" }}
                  >
                    <input
                      type="text"
                      placeholder="Consistency Score"
                      className="search_input"
                      value={searchValue.consistency || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          setSearchValue((pre) => ({
                            ...pre,
                            consistency: val,
                          }));
                        }
                      }}
                    />
                  </div>
                  <div
                    className="col1_bottom_lower"
                    style={{ minWidth: "250px", width: "100%" }}
                  >
                    <Select
                      placeholder="Sort By Payable Amount"
                      isMulti={false}
                      className="react-select-country"
                      options={[
                        { label: "All", value: "all" },
                        { label: "Low To High", value: "amount_payable" },
                        { label: "High To Low", value: "-amount_payable" },
                      ]}
                      value={
                        [
                          { label: "All", value: "all" },
                          { label: "Low To High", value: "amount_payable" },
                          { label: "High To Low", value: "-amount_payable" },
                        ].find((item) => item.value === searchValue.ordering) ||
                        null
                      }
                      onChange={(selectedOption) => {
                        setSearchValue((pre) => ({
                          ...pre,
                          ordering: selectedOption?.value || "",
                        }));
                      }}
                    />
                  </div>
                </>
              )}
            </div>
            {activeTab === 7 && (
              <div className="payout_tracker_inline_stats">
                <div className="stat_item">
                  <span className="stat_label">Overall Payable Amount:</span>
                  <span className="stat_value payable_amount">
                    {formatCurrency(displayedOverallStats.overall_payable_amount)}
                  </span>
                </div>
                <div className="divider" />
                <div className="stat_item">
                  <span className="stat_label">Overall Number of Payouts:</span>
                  <span className="stat_value">
                    {displayedOverallStats.overall_number_of_payouts}
                  </span>
                </div>
              </div>
            )}
          </div>

          <div className="filters_right_side">
            <div className="datepicker_wrapper">
              <DateRangePicker
                className="datepicker-date"
                character=" – "
                placeholder="DD/MM/YYYY – DD/MM/YYYY"
                onChange={handleDateChange}
                value={selectedDates}
                placement="bottomEnd"
                showOneCalendar={windowWidth < 1200}
                popperOptions={{
                  modifiers: [
                    {
                      name: "flip",
                      enabled: false,
                    },
                  ],
                }}
              />
            </div>
            <div className="actions_wrapper">
              {activeTab === 7 ? (
                <Button
                  onClick={handleReset}
                  className="clear-btn"
                >
                  Clear
                </Button>
              ) : (
                <button
                  className="reset_btn"
                  onClick={handleReset}
                >
                  Clear
                </button>
              )}
              {activeTab === 7 && (
                <Button
                  type="primary"
                  onClick={handleExportCsv}
                  loading={exportLoading}
                  disabled={isDirty}
                  className="export-btn"
                >
                  Export CSV
                </Button>
              )}
              {activeTab === 7 && (
                <Button
                  type="primary"
                  onClick={handleSubmit}
                  className="submit-btn"
                  style={{
                    backgroundColor: selectedBrand?.brand === "crypto_edge" ? "#fcd535" : "#36d66b",
                    borderColor: selectedBrand?.brand === "crypto_edge" ? "#fcd535" : "#36d66b",
                    color: selectedBrand?.brand === "crypto_edge" ? "black" : "#fff",
                  }}
                >
                  Submit
                </Button>
              )}
              
            </div>
          </div>
        </div>
        <br />
        <Routes>
          <Route path="/" element={<Navigate to="overview" replace={true} />} />

          <Route
            path="overview"
            element={
              <OverviewSection
                riskData={(riskData && riskData) || {}}
                selectedBrand={selectedBrand}
              />
            }
          />
          <Route
            path="countrywise"
            element={
              <>
                <Table
                  data={
                    riskData?.overview?.risk_management?.countrywise_stats || []
                  }
                  columns={columns}
                />
              </>
            }
          />
          <Route
            path="payout-lists"
            element={
              <>
                <div
                  className="papercon funded rowOne payouts"
                  style={{ marginBottom: "20px", alignItems: "center" }}
                >
                  <div className="filter_tab_inner_div">
                    <p style={{ margin: "0px 0px 5px 5px" }} htmlFor="">
                      Select Plan Type
                    </p>
                    <Select
                      className="plan_selector"
                      options={planOptions}
                      styles={"customStyles"}
                      value={selectedPlanValue}
                      onChange={(selectedOption) => {
                        setSelectedPlanValue(selectedOption);
                      }}
                    />
                  </div>
                  <div className="filter_tab_inner_div">
                    {" "}
                    <p style={{ margin: "0px 0px 5px 5px" }} htmlFor="">
                      Select Account Size
                    </p>
                    <Select
                      className="plan_selector"
                      options={accountSizeOption}
                      styles={"customStyles"}
                      value={accountSizeValue}
                      onChange={(selectedOption) => {
                        setAccountSizeValue(selectedOption);
                      }}
                    />
                  </div>
                </div>
                <div className="papercon funded rowOne payouts">
                  <div>
                    <div className="HeadT">Total Approved Payouts</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            payoutStats[accountSizeValue?.value]?.approved || 0,
                          )
                        : formatCurrency(payoutStats?.approved || 0)}
                    </div>
                  </div>
                  <div>
                    <div className="HeadT">Total Pending Payouts</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            payoutStats[accountSizeValue?.value]?.new || 0,
                          )
                        : formatCurrency(payoutStats?.new || 0)}
                    </div>
                  </div>
                  <div>
                    <div className="HeadT">Total Rejected Payouts</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            payoutStats[accountSizeValue?.value]?.rejected || 0,
                          )
                        : formatCurrency(payoutStats?.rejected || 0)}
                    </div>
                  </div>
                  <div>
                    <div className="HeadT">Total Approved count</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? payoutStats[accountSizeValue?.value]
                            ?.approved_count || 0
                        : payoutStats?.approved_count || 0}
                    </div>
                  </div>
                  <div>
                    <div className="HeadT">Total Pending Count</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? payoutStats[accountSizeValue?.value]?.pending_count ||
                          0
                        : payoutStats?.pending_count || 0}
                    </div>
                  </div>
                  <div>
                    <div className="HeadT">Total Rejected Count</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? payoutStats[accountSizeValue?.value]?.reject_count ||
                          0
                        : payoutStats?.reject_count || 0}
                    </div>
                  </div>
                  <div>
                    <div className="HeadT">Total Payouts Count</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? payoutStats[accountSizeValue?.value]?.total_payouts ||
                          0
                        : payoutStats?.total_payouts || 0}
                    </div>
                  </div>
                </div>

                <br />
                <Table
                  tableFilter={
                    <div className="papercon">
                      <div
                        className="col1_bottom_lower"
                        style={{
                          display: "flex",
                          gap: "20px",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <p style={{ margin: "0px 0px 5px 5px" }} htmlFor="">
                            Search Email
                          </p>
                          <input
                            type="text"
                            id="country"
                            className="search_input"
                            placeholder="Search by email"
                            onKeyDown={(e) => {
                              let value = e.target.value;
                              if (e.key === "Enter") {
                                setSearchValue((pre) => ({
                                  ...pre,
                                  email: value,
                                }));
                              }
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  }
                  data={(() => {
                    const tableData =
                      selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? Array.isArray(payoutList?.[accountSizeValue?.value])
                          ? payoutList[accountSizeValue?.value]
                          : []
                        : Array.isArray(payoutList)
                          ? payoutList
                          : [];
                    console.log("Table data:", {
                      selectedBrand,
                      accountSizeValue,
                      payoutList,
                      tableData,
                    });
                    return tableData;
                  })()}
                  columns={columnsForPayout}
                />
              </>
            }
          />
          <Route
            path="revenue-management"
            element={
              <>
                <div
                  className="papercon funded rowOne payouts"
                  style={{ marginBottom: "20px", alignItems: "center" }}
                >
                  <div className="filter_tab_inner_div">
                    <p>Select Plan Type</p>
                    <Select
                      className="plan_selector"
                      options={revenuePlanOptions}
                      styles={"customStyles"}
                      value={selectedRevenuePlan}
                      onChange={(selectedOption) => {
                        setSelectedRevenuePlan(selectedOption);
                      }}
                    />
                  </div>
                  <div className="filter_tab_inner_div">
                    <p style={{ margin: "0px 0px 5px 5px" }} htmlFor="">
                      Select Account Size
                    </p>
                    <Select
                      className="plan_selector"
                      options={accountSizeOption}
                      styles={"customStyles"}
                      value={accountSizeValue}
                      onChange={(selectedOption) => {
                        setAccountSizeValue(selectedOption);
                      }}
                    />
                  </div>
                </div>
                <div className="papercon funded rowOne payouts">
                  <div>
                    <div className="HeadT">Total Revenue</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.total_revenue) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.total_revenue || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Successful Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.succeeded_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.succeeded_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Expired Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.expired_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.expired_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Pending Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.open_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.open_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Filtered Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.filtered_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.filtered_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Unpaid Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.unpaid_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.unpaid_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Declined Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.declined_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.declined_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Processing Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.processing_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.processing_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Approved Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.approved_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.approved_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Created Payments Amount</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? formatCurrency(
                            (paymentStats &&
                              paymentStats[accountSizeValue?.value]
                                ?.created_amount) ||
                              0,
                          )
                        : paymentStats &&
                          formatCurrency(paymentStats?.created_amount || 0)}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Succeeded Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.succeeded) ||
                          0
                        : (paymentStats && paymentStats?.succeeded) || 0}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Expired Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.expired) ||
                          0
                        : (paymentStats && paymentStats?.expired) || 0}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Pending Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.open) ||
                          0
                        : (paymentStats && paymentStats?.open) || 0}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Filtered Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.filtered) ||
                          0
                        : (paymentStats && paymentStats?.filtered) || 0}
                      {}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Unpaid Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.unpaid) ||
                          0
                        : (paymentStats && paymentStats?.unpaid) || 0}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Declined Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.declined) ||
                          0
                        : (paymentStats && paymentStats?.declined) || 0}
                      {}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Processing Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]
                              ?.processing) ||
                          0
                        : (paymentStats && paymentStats?.processing) || 0}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Approved Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.approved) ||
                          0
                        : (paymentStats && paymentStats?.approved) || 0}
                    </div>
                  </div>

                  <div>
                    <div className="HeadT">Created Payments</div>
                    <div className="TextB">
                      {selectedBrand?.brand === "equity_edge" ||
                      selectedBrand?.brand === "crypto_edge"
                        ? (paymentStats &&
                            paymentStats[accountSizeValue?.value]?.created) ||
                          0
                        : (paymentStats && paymentStats?.created) || 0}
                    </div>
                  </div>
                </div>

                <br />
                <div className="overview_section">
                  <div className="papercon">
                    <div className="col1_bottom_lower">
                      {riskData && revenueList ? (
                        selectedBrand?.brand === "equity_edge" ||
                        selectedBrand?.brand === "crypto_edge" ? (
                          <StageStatistics
                            title="Revenue Management"
                            seriesData={[
                              {
                                name: "Revenue",
                                data:
                                  revenueList?.[accountSizeValue?.value]?.map(
                                    (item) => item.revenue_from_payments,
                                  ) || [],
                              },
                            ]}
                            categories={
                              revenueList?.[accountSizeValue?.value]?.map(
                                (item) => item.date.trim(),
                              ) || []
                            }
                            colors={["#4CB944", "#FF5733"]}
                            sidebarType={"Revenue"}
                          />
                        ) : (
                          Array.isArray(revenueList) && (
                            <StageStatistics
                              title="Revenue Management"
                              seriesData={[
                                {
                                  name: "Revenue",
                                  data: revenueList.map(
                                    (item) => item.revenue_from_payments,
                                  ),
                                },
                              ]}
                              categories={revenueList.map((item) =>
                                item.date.trim(),
                              )}
                              colors={["#4CB944", "#FF5733"]}
                              sidebarType={"Revenue"}
                            />
                          )
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
                <br />
                <Table
                  data={
                    riskData && revenueList
                      ? selectedBrand?.brand === "equity_edge" ||
                        selectedBrand?.brand === "crypto_edge"
                        ? Array.isArray(revenueList[accountSizeValue?.value])
                          ? revenueList[accountSizeValue?.value]
                          : []
                        : Array.isArray(revenueList)
                          ? revenueList
                          : []
                      : []
                  }
                  columns={columnsForRevenue}
                />
              </>
            }
          />
          <Route
            path="step_1"
            element={
              <StepOne
                data={
                  riskData?.overview?.risk_management?.risk_management_stats
                    ?.step1
                }
              />
            }
          />
          <Route
            path="step_2"
            element={
              <StepTwo
                data={
                  riskData?.overview?.risk_management?.risk_management_stats
                    ?.step2
                }
              />
            }
          />
          <Route
            path="pro_edge"
            element={
              <ProEdge
                data={
                  riskData?.overview?.risk_management?.risk_management_stats
                    ?.proedge ||
                  riskData?.overview?.risk_management?.risk_management_stats
                    ?.instant_funded
                }
                proEdgePayoutStats={riskData}
              />
            }
          />
          <Route
            path="payout-tracker"
            element={
              <PayoutTracker
                searchValue={searchValue}
                submittedSearchValue={submittedSearchValue}
                isDirty={isDirty}
                overallStats={overallStats}
                setOverallStats={setOverallStats}
              />
            }
          />
        </Routes>
      </div>
    </>
  );
}

export default AdminOverview;

const Table = ({ data, columns, tableFilter }) => {
  const [gotoPageInput, setGotoPageInput] = useState("");

  // Define the number of items per page
  const itemsPerPage = 15;

  // Only allow sorting when column.enableSortBy === true
  const sortableColumns = React.useMemo(
    () =>
      (columns || []).map((col) => ({
        ...col,
        // react-table expects disableSortBy flag; default to disabled unless explicitly enabled
        disableSortBy: col.enableSortBy === true ? false : true,
      })),
    [columns],
  );

  // Use react-table hooks with sorting and pagination
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page, // Instead of rows, use page for paginated data
    gotoPage,
    pageOptions,
    state: { pageIndex },
  } = useTable(
    {
      columns: sortableColumns,
      data,
      initialState: { pageIndex: 0, pageSize: itemsPerPage }, // Set initial page size
    },
    useSortBy,
    usePagination,
  );

  const handlePageChange = (event, newPage) => {
    gotoPage(newPage - 1); // Pagination component uses 1-based index
  };

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10) - 1; // Convert to 0-based index
    if (
      !isNaN(pageNumber) &&
      pageNumber >= 0 &&
      pageNumber < pageOptions.length
    ) {
      gotoPage(pageNumber);
      setGotoPageInput("");
    } else {
      alert("Please enter a valid page number.");
    }
  };

  return (
    <div className="traderslist" style={{ backgroundColor: "#fff" }}>
      {tableFilter}
      <div className="table_scroll">
        <div className="alltable" style={{ padding: "0px" }}>
          <div className="table_wrapper">
            <table {...getTableProps()} className="table">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    key={headerGroup.id}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps(),
                        )}
                        key={column.id}
                        style={{
                          cursor: column.canSort ? "pointer" : "default",
                        }}
                      >
                        <span>{column.render("Header")}</span>
                        {column.canSort && (
                          <span style={{ marginLeft: 6 }}>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? "▼"
                                : "▲"
                              : "↕"}
                          </span>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map((cell) => (
                        <td {...cell.getCellProps()} key={cell.column.id}>
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="spacerT30p"></div>
          <div
            style={{ display: "flex", alignItems: "center", gap: "20px" }}
            className="pagination_container pagination_wrapper"
          >
            <Pagination
              count={pageOptions.length}
              variant="outlined"
              color="primary"
              page={pageIndex + 1} // Convert to 1-based index for the UI
              onChange={handlePageChange}
              defaultPage={1}
              siblingCount={0}
              boundaryCount={1}
            />
            <div className="goto-page-input">
              <input
                type="text"
                placeholder="Go to Page"
                value={gotoPageInput}
                onChange={(e) => setGotoPageInput(e.target.value)}
              />
              <button className="goToButton" onClick={handleGotoPage}>
                Go
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const OverviewSection = ({ riskData, selectedBrand }) => {
  const data = riskData?.overview?.risk_management;
  const columns = React.useMemo(
    () => [
      {
        Header: "Start Date",
        accessor: "start_date", // maps to start_date in data
        width: 100,
      },
      {
        Header: "Profit/Loss",
        accessor: "p_n", // maps to p_n in data
        width: 100,
        Cell: ({ value }) => (
          <div
            style={{
              color: value === "profit" ? "#4cb944" : "#ff5733",
              textTransform: "capitalize",
            }}
          >
            {value}
          </div>
        ), // Optional, to display capitalized text
      },
      {
        Header: "P&L Amount",
        accessor: "pnl", // maps to pnl in data
        width: 100,
        Cell: ({ value }) => (
          <div
            style={{ color: value > 0 ? "#4cb944" : value < 0 && "#ff5733" }}
          >
            {formatCurrency(value)}
          </div>
        ), // Formats P&L to currency
      },
      {
        Header: "Starting Balance",
        accessor: "starting_balance", // maps to starting_balance in data
        width: 100,
        Cell: ({ value }) => formatCurrency(value), // Adds commas for large numbers
      },
    ],
    [],
  );
  return (
    <div className="overview_section">
      <div className="papercon funded rowOne">
        <div className="funded_section">
          <div className="HeadT"> Funded Loss</div>
          <div
            className="TextB"
            style={{
              color:
                data?.funded_loss < 0
                  ? "#ff5733"
                  : data?.funded_loss > 0 && "#4cb944",
            }}
          >
            {formatCurrency(data?.funded_loss || 0)}
          </div>
        </div>

        <div>
          <div className="HeadT">Funded Profit</div>
          <div className="TextB" style={{ color: "#4cb944" }}>
            {formatCurrency(data?.funded_profit || 0)}
          </div>
        </div>

        <div>
          <div className="HeadT">Funded Total</div>
          <div className="TextB">{formatCurrency(data?.funded_total || 0)}</div>
        </div>

        <div>
          <div className="HeadT">Funded PNL</div>
          <div
            className="TextB"
            style={{
              color:
                data?.funded_pnl_total < 0
                  ? "#ff5733"
                  : data?.funded_pnl_total > 0 && "#4cb944",
            }}
          >
            {formatCurrency(data?.funded_pnl_total || 0)}
          </div>
        </div>

        <div className="funded_section">
          <div className="HeadT">Coin Payments</div>
          <div className="TextB">
            {formatCurrency(data?.revenue_growth?.coinpayments || 0)}
          </div>
        </div>

        {selectedBrand?.brand === "equity_edge" && (
          <div>
            <div className="HeadT">Stripe</div>
            <div className="TextB">
              {formatCurrency(data?.revenue_growth?.stripe || 0)}
            </div>
          </div>
        )}
        <div>
          <div className="HeadT">Fibonatix</div>
          <div className="TextB">
            {formatCurrency(data?.revenue_growth?.fibonatix || 0)}
          </div>
        </div>

        {selectedBrand?.brand === "equity_edge" && (
          <div>
            <div className="HeadT">Paytiko</div>
            <div className="TextB">
              {formatCurrency(data?.revenue_growth?.paytiko || 0)}
            </div>
          </div>
        )}

        <div>
          <div className="HeadT">Rapyd</div>
          <div className="TextB">
            {formatCurrency(data?.revenue_growth?.rapyd || 0)}
          </div>
        </div>
        <div>
          <div className="HeadT">Nace</div>
          <div className="TextB">
            {formatCurrency(data?.revenue_growth?.nace || 0)}
          </div>
        </div>
      </div>

      <div className="papercon">
        <div className="col1_bottom_lower">
          <StageStatistics
            title="Payouts Requested & Approved"
            seriesData={[
              {
                name: "Payout Approved",
                data:
                  (data &&
                    data?.revenue_management?.payment_requested_approved?.map(
                      (item) => item.payout_approved,
                    )) ||
                  [],
              },
              {
                name: "Payout Requested",
                data:
                  (data &&
                    data?.revenue_management?.payment_requested_approved?.map(
                      (item) => item.payout_requested,
                    )) ||
                  [],
              },
            ]}
            categories={data?.revenue_management?.payment_requested_approved?.map(
              (item) => item?.date || [],
            )}
            colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            chartType="bar"
            sidebarType={"Amount (USD)"}
            bottomType={"Dates"}
            yAxisType={"USD"}
          />
        </div>
      </div>
      <div className="papercon">
        <div className="col1_bottom_lower">
          <StageStatistics
            title="Funded Accounts"
            seriesData={[
              {
                name: "Count",
                data:
                  (data &&
                    data?.revenue_management?.funded_accounts?.map(
                      (item) => item.count,
                    )) ||
                  [],
              },
            ]}
            categories={data?.revenue_management?.funded_accounts?.map(
              (item) => item.month.trim() || [],
            )}
            colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            chartType="bar"
            sidebarType={"Count"}
            bottomType={"Month"}
          />
        </div>
      </div>
      <Table
        data={data?.funded_data || []}
        columns={columns}
        tableFilter={<h3 className="chart_title">Funded Data List</h3>}
      />
    </div>
  );
};

const StepOne = ({ data }) => {
  console.log(data, "datadata");
  return (
    <>
      <div className="overview_section">
        <div className="papercon funded rowOne payouts">
          <ApexChart
            series={(data && Object.values(data?.step1_stage1_stats)) || []}
            labels={
              (data &&
                Object.keys(data?.step1_stage1_stats)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="1 Stage Stats"
            colors={["#4CB944", "#FF5733", "#FFD700", "#58bdff"]}
          />
          <ApexChart
            series={(data && Object.values(data?.payout_rev)) || []}
            labels={
              (data &&
                Object.keys(data?.payout_rev)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="1 Step Payout Revenue"
            colors={["#4CB944", "#FF5733"]}
          />
          <ApexChart
            series={(data && Object.values(data?.step1_funded_stats)) || []}
            labels={
              (data &&
                Object.keys(data?.step1_funded_stats)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="Funded Stats"
            colors={["#FFD700", "#FF5733", "#58bdff"]}
          />
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (1 Stage)"
              seriesData={[
                {
                  name: "Total Passed",
                  data:
                    (data &&
                      data?.step1_stage1?.map((item) => item.total_passed)) ||
                    [],
                },
                {
                  name: "Total Failed",
                  data:
                    (data &&
                      data?.step1_stage1?.map((item) => item.total_failed)) ||
                    [],
                },
              ]}
              categories={data?.step1_stage1?.map(
                (item) => item?.day?.trim() || [],
              )}
              colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            />
          </div>
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (Funded)"
              seriesData={[
                {
                  name: "Total Failed",
                  data:
                    (data &&
                      data?.step1_funded?.map((item) => item.total_failed)) ||
                    [],
                },
                {
                  name: "Total In Progress",
                  data:
                    (data &&
                      data?.step1_funded?.map(
                        (item) => item.total_in_progress,
                      )) ||
                    [],
                },
              ]}
              categories={data?.step1_funded?.map(
                (item) => item.start_date.trim() || [],
              )}
              colors={["#FF5733", "#ffca28"]} // Optional: pass different colors
            />
          </div>
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (Funded PNL)"
              seriesData={[
                {
                  name: "Funded Profit",
                  data:
                    (data &&
                      data?.step1_funded_pnl?.map(
                        (item) => item.funded_profit,
                      )) ||
                    [],
                },
                {
                  name: "Funded Loss",
                  data:
                    (data &&
                      data?.step1_funded_pnl?.map(
                        (item) => item.funded_loss,
                      )) ||
                    [],
                },
              ]}
              categories={data?.step1_funded_pnl?.map(
                (item) => item.date.trim() || [],
              )}
              colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            />
          </div>
        </div>
      </div>
    </>
  );
};
const StepTwo = ({ data }) => {
  console.log(data, "datadata");
  return (
    <>
      <div className="overview_section">
        <div className="papercon funded rowOne payouts">
          <ApexChart
            series={(data && Object.values(data?.step2_stats)) || []}
            labels={
              (data &&
                Object.keys(data?.step2_stats)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="Overall 2 Step Stats"
            colors={["#4CB944", "#FF5733", "#FFD700", "#58bdff"]}
          />
          <ApexChart
            series={(data && Object.values(data?.step2_stage1_stats)) || []}
            labels={
              (data &&
                Object.keys(data?.step2_stage1_stats)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="1 Stage Stats"
            colors={["#4CB944", "#FF5733", "#FFD700", "#58bdff"]}
          />
          <ApexChart
            series={(data && Object.values(data?.step2_stage2_stats)) || []}
            labels={
              (data &&
                Object.keys(data?.step2_stage2_stats)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="2 Stage Stats"
            colors={["#4CB944", "#FF5733", "#FFD700", "#58bdff"]}
          />
          <ApexChart
            series={(data && Object.values(data?.payout_rev)) || []}
            labels={
              (data &&
                Object.keys(data?.payout_rev)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="2 Step Payout Revenue"
            colors={["#4CB944", "#FF5733"]}
          />
          <ApexChart
            series={(data && Object.values(data?.step2_funded_stats)) || []}
            labels={
              (data &&
                Object.keys(data?.step2_funded_stats)?.map((key) => {
                  return key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                })) ||
              []
            }
            chartHeading="Funded Stats"
            colors={["#FFD700", "#FF5733", "#58bdff"]}
          />
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (1 Stage)"
              seriesData={[
                {
                  name: "Total Passed",
                  data:
                    (data &&
                      data?.step2_stage1?.map((item) => item.total_passed)) ||
                    [],
                },
                {
                  name: "Total Failed",
                  data:
                    (data &&
                      data?.step2_stage1?.map((item) => item.total_failed)) ||
                    [],
                },
              ]}
              categories={data?.step2_stage1?.map(
                (item) => item?.day?.trim() || [],
              )}
              colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            />
          </div>
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (2 Stage)"
              seriesData={[
                {
                  name: "Total Passed",
                  data:
                    (data &&
                      data?.step2_stage2?.map((item) => item.total_passed)) ||
                    [],
                },
                {
                  name: "Total Failed",
                  data:
                    (data &&
                      data?.step2_stage2?.map((item) => item.total_failed)) ||
                    [],
                },
              ]}
              categories={data?.step2_stage2?.map(
                (item) => item?.day?.trim() || [],
              )}
              colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            />
          </div>
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (Funded)"
              seriesData={[
                {
                  name: "Total Failed",
                  data:
                    (data &&
                      data?.step2_funded?.map((item) => item.total_failed)) ||
                    [],
                },
                {
                  name: "Total In Progress",
                  data:
                    (data &&
                      data?.step2_funded?.map(
                        (item) => item.total_in_progress,
                      )) ||
                    [],
                },
              ]}
              categories={data?.step2_funded?.map(
                (item) => item.start_date.trim() || [],
              )}
              colors={["#FF5733", "#ffca28"]} // Optional: pass different colors
            />
          </div>
        </div>
        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title="Risk Management Stats (Funded PNL)"
              seriesData={[
                {
                  name: "Funded Profit",
                  data:
                    (data &&
                      data?.step2_funded_pnl?.map(
                        (item) => item.funded_profit,
                      )) ||
                    [],
                },
                {
                  name: "Funded Loss",
                  data:
                    (data &&
                      data?.step2_funded_pnl?.map(
                        (item) => item.funded_loss,
                      )) ||
                    [],
                },
              ]}
              categories={data?.step2_funded_pnl?.map(
                (item) => item.date.trim() || [],
              )}
              colors={["#4CB944", "#FF5733"]} // Optional: pass different colors
            />
          </div>
        </div>
      </div>
    </>
  );
};
const ProEdge = ({ data, proEdgePayoutStats }) => {
  const planStats =
    proEdgePayoutStats?.planwise_payout_stats?.proedge?.total ||
    proEdgePayoutStats?.planwise_payout_stats?.instant_funded?.total;
  const planType = data?.proedge_stats ? "proedge" : "instant_funded";

  return (
    <>
      <div
        className="papercon funded rowOne payouts"
        style={{ marginBottom: "20px" }}
      >
        <div>
          <div className="HeadT">Total Approved Payouts</div>
          <div className="TextB">
            {formatCurrency(planStats?.approved || 0)}
          </div>
        </div>
        <div>
          <div className="HeadT">Total Pending Payouts</div>
          <div className="TextB">{formatCurrency(planStats?.new || 0)}</div>
        </div>
        <div>
          <div className="HeadT">Total Rejected Payouts</div>
          <div className="TextB">
            {formatCurrency(planStats?.rejected || 0)}
          </div>
        </div>
        <div>
          <div className="HeadT">Total Approved Count</div>
          <div className="TextB">{planStats?.approved_count || 0}</div>
        </div>
        <div>
          <div className="HeadT">Total Pending Count</div>
          <div className="TextB">{planStats?.pending_count || 0}</div>
        </div>
        <div>
          <div className="HeadT">Total Rejected Count</div>
          <div className="TextB">{planStats?.reject_count || 0}</div>
        </div>
        <div>
          <div className="HeadT">Total Payouts Count</div>
          <div className="TextB">{planStats?.total_payouts || 0}</div>
        </div>
      </div>

      <div className="overview_section">
        <div className="papercon funded rowOne payouts">
          <ApexChart
            series={(data && Object.values(data?.[`${planType}_stats`])) || []}
            labels={
              (data &&
                Object.keys(data?.[`${planType}_stats`])?.map((key) =>
                  key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase()),
                )) ||
              []
            }
            chartHeading={`${
              planType === "proedge" ? "ProEdge" : "Instant Funding"
            } Stats`}
            colors={["#4CB944", "#FF5733", "#FFD700", "#58bdff"]}
          />
          <ApexChart
            series={(data && Object.values(data?.payout_rev)) || []}
            labels={
              (data &&
                Object.keys(data?.payout_rev)?.map((key) =>
                  key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase()),
                )) ||
              []
            }
            chartHeading={`${
              planType === "proedge" ? "ProEdge" : "Instant Funding"
            } Payout Revenue`}
            colors={["#4CB944", "#FF5733"]}
          />
        </div>

        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title={`${
                planType === "proedge" ? "Pro Edge" : "Instant Funding"
              } Accounts`}
              seriesData={[
                {
                  name: "Counts",
                  data:
                    (data &&
                      data?.[`${planType}_accounts`]?.map(
                        (item) => item.account,
                      )) ||
                    [],
                },
              ]}
              categories={
                data?.[`${planType}_accounts`]?.map(
                  (item) => item?.month?.trim() || [],
                ) || []
              }
              colors={["#4CB944", "#FF5733"]}
              chartType="bar"
              sidebarType={"Count"}
              bottomType={"Month"}
            />
          </div>
        </div>

        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title={`Risk Management Stats (Daily Stats) - ${
                planType === "proedge" ? "Pro Edge" : "Instant Funding"
              }`}
              seriesData={[
                {
                  name: "Total Active",
                  data:
                    (data &&
                      data?.[`${planType}_stats_daily`]?.map(
                        (item) => item.total_active,
                      )) ||
                    [],
                },
                {
                  name: "Total Failed",
                  data:
                    (data &&
                      data?.[`${planType}_stats_daily`]?.map(
                        (item) => item.total_failed,
                      )) ||
                    [],
                },
              ]}
              categories={
                data?.[`${planType}_stats_daily`]?.map(
                  (item) => item.date.trim() || [],
                ) || []
              }
              colors={["#4CB944", "#FF5733"]}
            />
          </div>
        </div>

        <div className="papercon">
          <div className="col1_bottom_lower">
            <StageStatistics
              title={`Risk Management Stats (${
                planType === "proedge" ? "Pro Edge PNL" : "Instant Funding PNL"
              })`}
              seriesData={[
                {
                  name:
                    planType === "proedge" ? "Pro Edge Profit" : "IF Profit",
                  data:
                    (data &&
                      data?.[`${planType}_pnl`]?.map((item) => item.profit)) ||
                    [],
                },
                {
                  name: planType === "proedge" ? "Pro Edge Loss" : "IF Loss",
                  data:
                    (data &&
                      data?.[`${planType}_pnl`]?.map((item) => item.loss)) ||
                    [],
                },
              ]}
              categories={
                data?.[`${planType}_pnl`]?.map(
                  (item) => item.date.trim() || [],
                ) || []
              }
              colors={["#4CB944", "#FF5733"]}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const PayoutTracker = ({
  searchValue,
  submittedSearchValue,
  isDirty,
  overallStats,
  setOverallStats,
}) => {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const [trackerData, setTrackerData] = useState([]);
  const [chartData, setChartData] = useState([]);

  const fetchPayoutTracker = async () => {
    if (!submittedSearchValue) {
      setTrackerData([]);
      setChartData([]);
      return;
    }
    dispatch(setIsLoading(true));
    try {
      const params = {
        page_size: 10000,
      };
      if (submittedSearchValue?.start_date) {
        params.start_date = submittedSearchValue.start_date;
      }
      if (submittedSearchValue?.end_date) {
        params.end_date = submittedSearchValue.end_date;
      }
      if (submittedSearchValue?.account_type && submittedSearchValue.account_type !== "all") {
        params.account_type = submittedSearchValue.account_type;
      }
      if (submittedSearchValue?.consistency) {
        params.consistency = submittedSearchValue.consistency;
      }
      if (submittedSearchValue?.ordering && submittedSearchValue.ordering !== "all") {
        params.ordering = submittedSearchValue.ordering;
      }
      const response = await getPayoutTracker(idToken, params);
      if (response && response.status < 399) {
        if (Array.isArray(response.data)) {
          setTrackerData(response.data);
          setOverallStats({
            overall_payable_amount: response.data.reduce(
              (sum, item) => sum + (Number(item.amount_payable) || 0),
              0,
            ),
            overall_number_of_payouts: response.data.length,
          });
          setChartData([]);
        } else if (response.data && Array.isArray(response.data.results)) {
          setTrackerData(response.data.results);
          setOverallStats({
            overall_payable_amount: response.data.overall_payable_amount || 0,
            overall_number_of_payouts:
              response.data.overall_number_of_payouts || 0,
          });
          setChartData(response.data.chart_data || []);
        } else {
          setTrackerData([]);
          setOverallStats({
            overall_payable_amount: 0,
            overall_number_of_payouts: 0,
          });
          setChartData([]);
        }
      } else {
        dispatch(returnErrors("Error getting payout tracker data"));
        setTrackerData([]);
        setOverallStats({
          overall_payable_amount: 0,
          overall_number_of_payouts: 0,
        });
        setChartData([]);
      }
    } catch (err) {
      console.error("Error fetching payout tracker:", err);
      dispatch(returnErrors("Error fetching payout tracker data"));
      setTrackerData([]);
      setChartData([]);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  useEffect(() => {
    fetchPayoutTracker();
  }, [submittedSearchValue, idToken]);

  const columns = useMemo(
    () => [
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Account Number",
        accessor: "account_number",
      },
      {
        Header: "Account Type",
        accessor: "account_type",
      },
      {
        Header: "Account Size",
        accessor: "account_size",
        Cell: ({ value }) => formatCurrencyWithoutDecimal(value),
      },
      {
        Header: "Balance",
        accessor: "balance",
        Cell: ({ value }) => formatCurrency(value),
      },
      {
        Header: "Profit",
        accessor: "profit",
        Cell: ({ value }) => (
          <div
            style={{
              color: value > 0 ? "#4cb944" : value < 0 ? "#ff5733" : "inherit",
              fontWeight: 600,
            }}
          >
            {formatCurrency(value)}
          </div>
        ),
      },
      {
        Header: "Profit Current Cycle",
        accessor: "profit_current_cycle",
        Cell: ({ value }) => (
          <div
            style={{
              color: value > 0 ? "#4cb944" : value < 0 ? "#ff5733" : "inherit",
            }}
          >
            {formatCurrency(value)}
          </div>
        ),
      },
      {
        Header: "Amount Payable",
        accessor: "amount_payable",
        Cell: ({ value }) => (
          <div style={{ color: "#4cb944", fontWeight: 600 }}>
            {formatCurrency(value)}
          </div>
        ),
      },
      {
        Header: "Consistency Score",
        accessor: "consistency_score",
        Cell: ({ value }) =>
          value !== null && value !== undefined ? `${value}%` : "-",
      },
      {
        Header: "Payout Date",
        accessor: "payout_date",
        Cell: ({ value }) => (value ? moment(value).format("DD-MM-YYYY") : "-"),
      },
    ],
    [],
  );

  const dataList = useMemo(() => {
    let list = Array.isArray(trackerData) ? [...trackerData] : [];
    if (submittedSearchValue?.consistency) {
      const limit = Number(submittedSearchValue.consistency);
      if (!isNaN(limit)) {
        list = list.filter((item) => {
          const score = item.consistency_score;
          return (
            score === null || score === undefined || Number(score) <= limit
          );
        });
      }
    }
    if (submittedSearchValue?.ordering && submittedSearchValue.ordering !== "all") {
      if (submittedSearchValue.ordering === "amount_payable") {
        list.sort(
          (a, b) =>
            (Number(a.amount_payable) || 0) - (Number(b.amount_payable) || 0),
        );
      } else if (submittedSearchValue.ordering === "-amount_payable") {
        list.sort(
          (a, b) =>
            (Number(b.amount_payable) || 0) - (Number(a.amount_payable) || 0),
        );
      }
    }
    return list;
  }, [trackerData, submittedSearchValue?.consistency, submittedSearchValue?.ordering]);

  const totalAccounts = dataList.length;
  const totalBalance = dataList.reduce(
    (sum, item) => sum + (Number(item.balance) || 0),
    0,
  );
  const totalProfit = dataList.reduce(
    (sum, item) => sum + (Number(item.profit) || 0),
    0,
  );
  const totalAmountPayable = dataList.reduce(
    (sum, item) => sum + (Number(item.amount_payable) || 0),
    0,
  );

  return (
    <div className="overview_section">
      {isDirty ? (
        <div
          className="papercon"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "80px 40px",
            fontSize: "16px",
            color: "#8c8c8c",
            fontWeight: 500,
            borderRadius: "16px",
            backgroundColor: "#fff",
            border: "1px dashed #d9d9d9",
            textAlign: "center",
            minHeight: "200px",
          }}
        >
          No data presented. Please click "Submit" to load data for your current
          selection.
        </div>
      ) : (
        <>
          {chartData && chartData.length > 0 && (
            <>
              <div className="papercon">
                <div
                  className="col1_bottom_lower"
                  style={{ width: "100%", maxWidth: "none" }}
                >
                  <StageStatistics
                    title="Amount Payable"
                    chartType="bar"
                    seriesData={[
                      {
                        name: "Amount Payable",
                        data: chartData.map(
                          (item) => Number(item.amount_payable) || 0,
                        ),
                      },
                    ]}
                    categories={chartData.map((item) => item.date)}
                    colors={["#4CB944"]}
                    sidebarType="Amount Payable"
                    bottomType="Days"
                    yAxisType="USD"
                  />
                </div>
              </div>
            </>
          )}

          {/* Data Table */}
          <Table
            data={dataList}
            columns={columns}
            tableFilter={
              <div className="payout_tracker_table_filter">
                <h3 className="chart_title">Payout Tracker Data</h3>
              </div>
            }
          />
        </>
      )}
    </div>
  );
};
